import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectConfig } from '../../features/config/configSlice';
import type ConfigState from '../../interfaces/ConfigState';
import appStore from '../../images/app-store.png';
import playMarket from '../../images/play-market.png';
import { APP_STORE_LINKS, PLAY_STORE_LINKS } from '../../constants';

export default function DownloadLinks() {
  const { brand } = useSelector<ConfigState, ConfigState>(selectConfig);

  const appStoreLink = APP_STORE_LINKS[brand];
  const playStoreLink = PLAY_STORE_LINKS[brand];

  return (
    <div className="download-links__wrapper">
      <div>
        {appStoreLink && (
          <a href={appStoreLink} target="_blank" rel="noopener noreferrer">
            <img alt="App Store icon" src={appStore} />
          </a>
        )}
        {playStoreLink && (
          <a href={playStoreLink} target="_blank" rel="noopener noreferrer">
            <img alt="Play Store icon" src={playMarket} />
          </a>
        )}
      </div>
    </div>
  );
}
